import clsx from "clsx"
import { EnergyPassportDetailsQuarterRow } from "@/features/energy-passport/ui/detail-tables/components/energy-passport-details-quarter-row.tsx"
import { EnergyPassportDetailsTableHead } from "@/features/energy-passport/ui/detail-tables/components/energy-passport-details-table-head.tsx"
import type { IEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"
import { energyPassportDetailsCommonCells } from "@/features/energy-passport/ui/detail-tables/model/table-data.ts"
import type { ValueOf } from "@/shared/types/interfaces"

interface IProps {
  title: string
  storeItem: ValueOf<IEnergyPassportDetailsStore>
}

export function EnergyPassportDetailsTable({ title, storeItem }: IProps) {
  return (
    <>
      <p className="my-3 text-sm">{title}</p>
      <table className={clsx("base-table")}>
        <EnergyPassportDetailsTableHead />
        <tbody>
          <EnergyPassportDetailsQuarterRow cells={energyPassportDetailsCommonCells} storeItem={storeItem} />
        </tbody>
      </table>
    </>
  )
}
